import { useEffect, useState } from "react";
import { useLocation } from "wouter";
import { use_store } from "../store";
import { PaymentLoader } from "./Loading";

export default function SetToken() {
  const [, setLocation] = useLocation();
  const { set_token, refresh_current_user, t } = use_store();
  const [show_loader, set_show_loader] = useState(true);

  useEffect(() => {
    (async () => {
      const urlParams = new URLSearchParams(window.location.search);
      const new_token = urlParams.get("token");

      if (new_token) {
        await set_token(new_token);
        const refresh_user = await refresh_current_user()
        set_show_loader(false);
        if (!refresh_user.subscribed) {
          setLocation("/pay");
        } else {
          setLocation("/");
        }
      }
    })()
  }, [set_token, refresh_current_user]);

  return (
    <div className="flex flex-col w-full items-center justify-center min-h-[400px] gap-[24px]">
      {show_loader && <PaymentLoader />}
      <p className="bigt">{t("Logging you in...")}</p>
    </div>
  );
}
